import styled from "styled-components";

export const InputEmailStepWrapper = styled.div`
    button {
      margin-top: 10px;
    }
`;